import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { isEmpty } from 'lodash';

Vue.use(Vuex)

const SERVER_API_HOST = process.env.VUE_APP_SERVER_API_HOST;
const LIMIT_ITEMS_PER_PAGE = 10;
const INITIAL_STATE = {
  isLoggedIn: false,
  search: {
    params: {
      page: 1,
      year: null,
      search: null,
      therapeuticarea: null
    },
    results: [],
    count: null,
    pages: 0,
    perPage: LIMIT_ITEMS_PER_PAGE,
    therapeuticAreas: [],
    isSearching: false,
  },
  publication: {}
}

const store = new Vuex.Store({
  strict: true,
  state: Object.assign({}, INITIAL_STATE),
  mutations: {
    toggleLogin (state, payload) {
      state.isLoggedIn = payload;
    },

    toggleIsSearching( state, payload = true ) {
      state.search.isSearching = payload
    },
    setResults ( state, payload ) {
      state.search.results = payload.items;
      state.search.count   = payload.count;
      state.search.pages   = payload.pages;
      state.search.perPage = payload.perPage;
      state.search.therapeuticAreas = payload.therapeuticAreas;
      state.search.isSearching = false
    },

    setParams ( state, payload ) {
      state.search.params.page = parseInt(payload.page);
      state.search.params.search = payload.search;
      state.search.params.therapeuticarea = payload.therapeuticarea;
    },
    setSearchParam ( state, payload ) {
      state.search.params.page = 1;
      state.search.params.therapeuticarea = null;
      state.search.params.search = (isEmpty(payload) ? null : payload);
    },
    setPageParam ( state, payload ) {
      state.search.params.page = parseInt(payload);
    },
    setTherapeuticAreaParam ( state, payload ) {
      state.search.params.page = 1;
      state.search.params.therapeuticarea = payload;
    },
    setTherapeuticAreas ( state, payload ) {
      state.search.therapeuticarea = payload;
    },

    setPublication ( state, payload ) {
      state.publication = payload;
    }
  },
  actions: {
    login ({ commit }, { username, password }) {
      return new Promise( (resolve, reject) => {
        axios.post( `${SERVER_API_HOST}/login`, { username, password }, { withCredentials: true })
          .then( response => {
            commit( 'toggleLogin', true );
            resolve();
          })
          .catch( err => {
            reject( err.response.data.errors );
          })
      });
    },
    logout ({ commit, dispatch }) {
      return new Promise( (resolve, reject) => {
        axios.get( `${SERVER_API_HOST}/logout`, { withCredentials: true  } )
        .then( () => {
          commit( 'toggleLogin', false );
          dispatch( 'clearSearch' );
          resolve();
        })
      })
    },
    verifyAuthentification ({ commit }) {
      return new Promise( (resolve, reject) => {
        axios.get(`${SERVER_API_HOST}/is-logged-in`, { withCredentials: true })
        .then( response => {
          commit( 'toggleLogin', response.data )
          response.data ? resolve() : reject();
        })
        .catch( err => {
          console.error('unable to verify login', err);
          reject();
        });
      });
    },

    search({ commit, state } ) {
      // Bail if the user is not logged in
      if ( !state.isLoggedIn ) return;

      const params = Object.assign({limit: LIMIT_ITEMS_PER_PAGE}, state.search.params);
      axios.get( `${SERVER_API_HOST}/publications`, { params, withCredentials: true } )
        .then( response => {
          commit( 'setResults', response.data );
        })
    },
    clearSearch({ commit }) {
      commit( 'setSearchParam' );
      commit( 'setResults', INITIAL_STATE.search );
    },

    fetchPublication({ commit }, { id }) {
      axios.get( `${SERVER_API_HOST}/publications/${ id }`, { withCredentials: true } )
        .then( response => {
          commit( 'setPublication', response.data );
        })
    },
    clearPublication({ commit }) {
      commit( 'setPublication', {} );
    }
  }
});

/**
 * Watch any change in the search params,
 * and dispatch the search request to the server API
 */
store.watch( () => store.state.search.params, () => store.dispatch('search'), { deep: true } );

export default store;
